import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef, IconSpecificStyles } from './types';

export const Logout: IconDef = {
  svg: (
    <G>
      <Path
        strokeLinecap="round"
        strokeWidth={1.6}
        d="M16.4444 16.1667L22 12M22 12L16.4444 7.83333M22 12H8.66667M8.66667 4.5H7.33333C5.46649 4.5 4.53307 4.5 3.82003 4.77248C3.19283 5.01217 2.68289 5.39462 2.36331 5.86502C2 6.3998 2 7.09987 2 8.5V15.5C2 16.9001 2 17.6002 2.36331 18.135C2.68289 18.6054 3.19282 18.9878 3.82003 19.2275C4.53307 19.5 5.46649 19.5 7.33333 19.5H8.66667"
      />
    </G>
  ),
  svgStyles(color): IconSpecificStyles {
    return {
      stroke: color,
    };
  },
};
